/* Модели календаря (совместимо с Angular 7) */

import { Guid } from "guid-typescript";

export enum WsDayType {
  /**Рабочий день */
  Workday = 1,
  /**Выходной */
  Weekend = 2,
  /**Праздничный день */
  Holiday = 3,
  /**Предпраздничный день" */
  PreHoliday = 4,
  /**Отпуск */
  Vacation = 5,
  /**Отгул */
  DayOff = 6,
  /**Больничный */
  Sick = 7,
  /**Доп. рабочий день */
  Extra = 8,
  /**Без смены */
  Empty = 9,
  /**Командировка */
  BusinessTrip = 10,
}

export interface WsEmployee {
  id: Guid;
  name: string;
  shiftLabel?: string;   // например "5/2"
  days: WsDay[];
  events: WsEvent[];
  daysInfo: WsEmployeeDayInfo[];
}

export interface WsEvent {
  id: string;
  employeeId: Guid;
  type: WsDayType;
  start: Date;           // начало (день)
  end: Date;             // конец   (день, включительно)
  icon: string;
}

export interface WsMergedEvent {
  ids: string[];
  start: Date;
  end: Date;
  employeeId: Guid;
  type: WsDayType;
  icon: string;
}

export interface WsProdCalendarDay {
  day: Date;
  dayType: WsDayType;
}

export interface WsDay {
  date: Date;
  type: WsDayType;
}

export interface WsEmployeeDayInfo {
  date: Date;
  requestsCount: number;
}

export interface WsEmployeeLookup {
  id: Guid;
  name: string;
}

export interface WsScheduleLookup {
  id: number;
  name: string;
}

export interface WsList<T> {
  data: T[];
  totalCount: number;
}

export interface WsCreateEmployeeEventRequest {
  employeeIntegraCode: Guid;
  rangeDaysType: WsDayType;
  dateFrom: Date;
  dateTo: Date;
}

export interface WsCreateUpdateEmployeeTimeSheduleRequest {
  employeeIntegraCode: Guid;
  timeScheduleId: number;
  startsFrom: Date;
}

export interface WsUpdateEmployeeEventRequest {
  employeeIntegraCode: Guid;
  employeeCustomTimeScheduleId: number;
  rangeDaysType: WsDayType;
  dateFrom: Date;
  dateTo: Date;
}

export interface WsCreateUpdateEmployeeTimeSheduleRequest {
  employeeIntegraCode: Guid;
  timeScheduleId: number;
  startsFrom: Date;
}

export interface WsDeleteEmployeeEventsRequest {
  ids: number[];
}